import { ACTIONS } from './actions';
import {
  CONTRACT_VALUE_FIELDS,
  DIAGNOSTIC_CARD_VALUE_FIELDS,
  DISCOUNT_TYPE_VALUES,
  INVOICE_VALUE_FIELDS,
  PTS_VALUE_FIELDS,
  VALUE_FIELDS,
} from './fields';

/** @deprecated Нужно использовать "ACTIONS.GET_CAR_INSTANCE" */
export const { GET_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_CAR_INSTANCE" */
export const { SET_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.PATCH_CAR_INSTANCE" */
export const { PATCH_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_FETCH_CAR_INSTANCE" */
export const { SET_FETCH_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_ERROR_CAR_INSTANCE" */
export const { SET_ERROR_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.UPDATE_ERRORS_CAR_INSTANCE" */
export const { UPDATE_ERRORS_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.DROP_ERRORS_CAR_INSTANCE" */
export const { DROP_ERRORS_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.DROP_ONE_ERROR_CAR_INSTANCE" */
export const { DROP_ONE_ERROR_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.VALIDATE_CAR_INSTANCE" */
export const { VALIDATE_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.FORCE_VALIDATE_CAR_INSTANCE" */
export const { FORCE_VALIDATE_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_PATCHIG_CAR_INSTANCE" */
export const { SET_PATCHIG_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SCROLL_TO_INSTANCE" */
export const { SCROLL_TO_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.CLEAR_SCROLL_TO_INSTANCE" */
export const { CLEAR_SCROLL_TO_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.CLEAR_CAR_INSTANCE" */
export const { CLEAR_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.UPDATE_CAR_INSTANCE_ID" */
export const { UPDATE_CAR_INSTANCE_ID } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.GET_CAR_INSTANCE_BY_ID" */
export const { GET_CAR_INSTANCE_BY_ID } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_FETCH_CAR_INFO" */
export const { SET_FETCH_CAR_INFO } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.CHANGE_CAR_INSTANCE" */
export const { CHANGE_CAR_INSTANCE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.PATCH_IS_NEW" */
export const { PATCH_IS_NEW } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.GET_DEALERS_PARAMS" */
export const { GET_DEALERS_PARAMS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.CHANGE_DEALERS_PARAMS" */
export const { CHANGE_DEALERS_PARAMS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_FETCH_DEALERS_PARAMS" */
export const { SET_FETCH_DEALERS_PARAMS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_IMAGE" */
export const { SET_IMAGE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.DECLINE_DROP_ERRORS" */
export const { DECLINE_DROP_ERRORS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.OPEN_BLOCK" */
export const { OPEN_BLOCK } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.CLOSE_BLOCK" */
export const { CLOSE_BLOCK } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.OPEN_DETAILS" */
export const { OPEN_DETAILS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.CLOSE_DETAILS" */
export const { CLOSE_DETAILS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.DISABLE" */
export const { DISABLE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.ENABLE" */
export const { ENABLE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_COLLAPSABLE" */
export const { SET_COLLAPSABLE } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_CAR_REQUIRED_FIELDS" */
export const { SET_CAR_REQUIRED_FIELDS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_CAR_HIDDEN_FIELDS" */
export const { SET_CAR_HIDDEN_FIELDS } = ACTIONS;
/** @deprecated Нужно использовать "ACTIONS.SET_CAR_DISABLE_FIELDS" */
export const { SET_CAR_DISABLE_FIELDS } = ACTIONS;

/** @deprecated Нужно использовать "DISCOUNT_TYPE_VALUES" */
export const DISCOUNTS = {
  /** @deprecated Нужно использовать "DISCOUNT_TYPE_VALUES.MFR" */
  mfr: DISCOUNT_TYPE_VALUES.MFR,
  /** @deprecated Нужно использовать "DISCOUNT_TYPE_VALUES.DIRECT" */
  direct: DISCOUNT_TYPE_VALUES.DIRECT,
};

/** @deprecated Нужно использовать "VALUE_FIELDS" */
export const FIELDS = {
  /** @deprecated Нужно использовать "VALUE_FIELDS.ACCOUNT_NUMBER" */
  accountNumber: VALUE_FIELDS.ACCOUNT_NUMBER,
  /** @deprecated Нужно использовать "VALUE_FIELDS.BANK_NAME" */
  bankName: VALUE_FIELDS.BANK_NAME,
  /** @deprecated Нужно использовать "VALUE_FIELDS.BIC" */
  bic: VALUE_FIELDS.BIC,
  /** @deprecated Нужно использовать "VALUE_FIELDS.BODY_NUMBER" */
  bodyNumber: VALUE_FIELDS.BODY_NUMBER,
  /** @deprecated Нужно использовать "VALUE_FIELDS.BRAND" */
  brand: VALUE_FIELDS.BRAND,
  /** @deprecated Нужно использовать "VALUE_FIELDS.CAR_ISSUE_DATE" */
  carIssueDate: VALUE_FIELDS.CAR_ISSUE_DATE,
  /** @deprecated Нужно использовать "VALUE_FIELDS.CATALOG_BLOCK" */
  catalogBlock: VALUE_FIELDS.CATALOG_BLOCK,
  /**
   * @deprecated
   * Нужно использовать<br/>
   * ```javascript
   * const { [VALUE_FIELDS.CONTRACT]: disabled } = useSelector(selectDisabled);
   * const { [VALUE_FIELDS.CONTRACT]: errors } = useSelector(selectErrors);
   * const { [VALUE_FIELDS.CONTRACT]: hidden } = useSelector(selectHidden);
   * const { [VALUE_FIELDS.CONTRACT]: values } = useSelector(selectValues);
   * ```
   * */
  contract: {
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.DATE]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.DATE]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.DATE]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.DATE]));
     * ```
     * */
    date: CONTRACT_VALUE_FIELDS.DATE,
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.NUMBER]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.NUMBER]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.NUMBER]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.CONTRACT, CONTRACT_VALUE_FIELDS.NUMBER]));
     * ```
     * */
    number: `${VALUE_FIELDS.CONTRACT}.${CONTRACT_VALUE_FIELDS.NUMBER}`,
  },
  /** @deprecated Нужно использовать "VALUE_FIELDS.DEFAULT_PRICE" */
  defaultPrice: VALUE_FIELDS.DEFAULT_PRICE,
  /**
   * @deprecated
   * Нужно использовать<br/>
   * ```javascript
   * const { [VALUE_FIELDS.DIAGNOSTIC_CARD]: disabled } = useSelector(selectDisabled);
   * const { [VALUE_FIELDS.DIAGNOSTIC_CARD]: errors } = useSelector(selectErrors);
   * const { [VALUE_FIELDS.DIAGNOSTIC_CARD]: hidden } = useSelector(selectHidden);
   * const { [VALUE_FIELDS.DIAGNOSTIC_CARD]: values } = useSelector(selectValues);
   * ```
   * */
  diagnosticCard: {
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE]));
     * ```
     * */
    beginDate: `${VALUE_FIELDS.DIAGNOSTIC_CARD}.${DIAGNOSTIC_CARD_VALUE_FIELDS.BEGIN_DATE}`,
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE]));
     * ```
     * */
    endDate: `${VALUE_FIELDS.DIAGNOSTIC_CARD}.${DIAGNOSTIC_CARD_VALUE_FIELDS.END_DATE}`,
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.DIAGNOSTIC_CARD, DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER]));
     * ```
     * */
    number: `${VALUE_FIELDS.DIAGNOSTIC_CARD}.${DIAGNOSTIC_CARD_VALUE_FIELDS.NUMBER}`,
  },
  /** @deprecated Нужно использовать "VALUE_FIELDS.ENGINE_NUMBER" */
  engineNumber: VALUE_FIELDS.ENGINE_NUMBER,
  /** @deprecated Нужно использовать "VALUE_FIELDS.ENGINE_POWER" */
  enginePower: VALUE_FIELDS.ENGINE_POWER,
  /** @deprecated Нужно использовать "VALUE_FIELDS.ENGINE_VOLUME" */
  engineVolume: VALUE_FIELDS.ENGINE_VOLUME,
  /** @deprecated Нужно использовать "VALUE_FIELDS.GLONAS_NUMBER" */
  glonasNumber: VALUE_FIELDS.GLONAS_NUMBER,
  /** @deprecated Нужно использовать "VALUE_FIELDS.INN" */
  inn: VALUE_FIELDS.INN,
  /**
   * @deprecated
   * Нужно использовать<br/>
   * ```javascript
   * const { [VALUE_FIELDS.INVOICE]: disabled } = useSelector(selectDisabled);
   * const { [VALUE_FIELDS.INVOICE]: errors } = useSelector(selectErrors);
   * const { [VALUE_FIELDS.INVOICE]: hidden } = useSelector(selectHidden);
   * const { [VALUE_FIELDS.INVOICE]: values } = useSelector(selectValues);
   * ```
   * */
  invoice: {
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.DATE]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.DATE]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.DATE]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.DATE]));
     * ```
     * */
    date: `${VALUE_FIELDS.INVOICE}.${INVOICE_VALUE_FIELDS.DATE}`,
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.NUMBER]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.NUMBER]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.NUMBER]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.INVOICE, INVOICE_VALUE_FIELDS.NUMBER]));
     * ```
     * */
    number: `${VALUE_FIELDS.INVOICE}.${INVOICE_VALUE_FIELDS.NUMBER}`,
  },
  /** @deprecated Нужно использовать "VALUE_FIELDS.IS_NEW" */
  isNew: VALUE_FIELDS.IS_NEW,
  /** @deprecated Нужно использовать "VALUE_FIELDS.MILEAGE" */
  mileage: VALUE_FIELDS.MILEAGE,
  /** @deprecated Нужно использовать "VALUE_FIELDS.MODEL" */
  model: VALUE_FIELDS.MODEL,
  /** @deprecated Нужно использовать "VALUE_FIELDS.NDS_AMOUNT" */
  ndsAmount: VALUE_FIELDS.NDS_AMOUNT,
  /** @deprecated Нужно использовать "VALUE_FIELDS.NDS_FLAG" */
  ndsFlag: VALUE_FIELDS.NDS_FLAG,
  /** @deprecated Нужно использовать "VALUE_FIELDS.OFFER_PRICE" */
  offerPrice: VALUE_FIELDS.OFFER_PRICE,
  /** @deprecated Нужно использовать "VALUE_FIELDS.PERMITTED_MAX_WEIGHT" */
  permittedMaxWeight: VALUE_FIELDS.PERMITTED_MAX_WEIGHT,
  /** @deprecated Нужно использовать "VALUE_FIELDS.PRICE" */
  price: VALUE_FIELDS.PRICE,
  /**
   * @deprecated
   * Нужно использовать<br/>
   * ```javascript
   * const { [VALUE_FIELDS.PTS]: disabled } = useSelector(selectDisabled);
   * const { [VALUE_FIELDS.PTS]: errors } = useSelector(selectErrors);
   * const { [VALUE_FIELDS.PTS]: hidden } = useSelector(selectHidden);
   * const { [VALUE_FIELDS.PTS]: values } = useSelector(selectValues);
   * ```
   * */
  pts: {
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.ISSUE_DATE]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.ISSUE_DATE]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.ISSUE_DATE]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.ISSUE_DATE]));
     * ```
     * */
    issueDate: `${VALUE_FIELDS.PTS}.${PTS_VALUE_FIELDS.ISSUE_DATE}`,
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.NUMBER]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.NUMBER]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.NUMBER]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.NUMBER]));
     * ```
     * */
    number: `${VALUE_FIELDS.PTS}.${PTS_VALUE_FIELDS.NUMBER}`,
    /**
     * @deprecated
     * Нужно использовать<br/>
     * ```javascript
     * const disabled = useSelector(selectNestedDisabled([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.SERIES]));
     * const errors = useSelector(selectNestedErrors([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.SERIES]));
     * const hidden = useSelector(selectNestedHidden([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.SERIES]));
     * const values = useSelector(selectNestedValues([VALUE_FIELDS.PTS, PTS_VALUE_FIELDS.SERIES]));
     * ```
     * */
    series: `${VALUE_FIELDS.PTS}.${PTS_VALUE_FIELDS.SERIES}`,
  },
  /** @deprecated Нужно использовать "VALUE_FIELDS.RECIPIENT" */
  recipient: VALUE_FIELDS.RECIPIENT,
  /** @deprecated Нужно использовать "VALUE_FIELDS.VERSION" */
  version: VALUE_FIELDS.VERSION,
  /** @deprecated Нужно использовать "VALUE_FIELDS.VIN" */
  vin: VALUE_FIELDS.VIN,
  /** @deprecated Нужно использовать "VALUE_FIELDS.YEAR" */
  year: VALUE_FIELDS.YEAR,
};
